import { __makeTemplateObject, __assign, __rest } from 'tslib';
import React from 'react';
import { css, styled } from 'styled-components';
import { resets } from '../utils/index.js';

var ulResets = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  display: block;\n  list-style-type: decimal;\n  margin-top: 1em;\n  margin-bottom: 1em;\n  margin-left: 0;\n  margin-right: 0;\n  padding-left: 40px;\n"], ["\n  ", "\n  ", "\n  display: block;\n  list-style-type: decimal;\n  margin-top: 1em;\n  margin-bottom: 1em;\n  margin-left: 0;\n  margin-right: 0;\n  padding-left: 40px;\n"])), resets.normalize.html, resets.common);
var Ul = function Ul(props) {
  return /*#__PURE__*/React.createElement("ul", __assign({}, props));
};
var HtmlUl = styled(Ul).withConfig({
  componentId: "sc-1jq8ne1-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ulResets);
var UlWithRef = function UlWithRef(_a) {
  var forwardRef = _a.forwardRef,
    passProps = __rest(_a, ["forwardRef"]);
  return /*#__PURE__*/React.createElement("ul", __assign({}, passProps, {
    ref: forwardRef
  }));
};
var HtmlUlWithRef = styled(UlWithRef).withConfig({
  componentId: "sc-1jq8ne1-1"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ulResets);
var templateObject_1, templateObject_2, templateObject_3;

export { HtmlUl, HtmlUlWithRef };
//# sourceMappingURL=HtmlUl.js.map
